<template>
  <section>
  <b-card title="">
    <b-row xl="12" sm="12">
      <b-col
        cols="12"
        md="5"
        class="mb-md-0 mb-2"
      >
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="ProvinceOptions" :reduce="ProvinceOptions => ProvinceOptions.value"
          id="v-Province" 
          v-model="select_6" 
          label="title"
          placeholder="--Select Province --"
          class="w-100"
        />
      </b-col>
      <b-col
        cols="12"
        md="5"
        class="mb-md-0 mb-2"
      >
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="RegencyOptions" :reduce="RegencyOptions => RegencyOptions.value"
          v-model="select_7" 
          label="title"
          id="v-Regency" 
          placeholder="--Select Regency --"
          class="w-100"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
        class="mb-md-0 mb-2"
      >
      <b-button class="sidebar-center" v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="filterz()" variant="outline-primary">
        <feather-icon icon="SearchIcon" /> Filter
      </b-button>
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="mb-md-0 mb-2"
      >
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="DistrictOptions" :reduce="DistrictOptions => DistrictOptions.value"
          v-model="select_8" 
          id="v-District" 
          label="title"
          placeholder="--Select District --"
          class="w-100" style="display: none;"
        />
      </b-col>
    </b-row>
  </b-card>
  <b-card-code title="" no-body>
    <div>
      <b-button class="ml-1 mb-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="exportExcel">
        <feather-icon icon="DownloadIcon" /> Export
      </b-button>  
    </div>
    <div><div class="h-50 d-inline-block"></div></div>
    <div class="d-flex justify-content-between flex-wrap">
      <!-- sorting  -->
      <b-form-group label="Sort" label-size="sm" label-align-sm="left" label-cols-sm="3" label-for="sortBySelect" class="ml-1">
        <b-input-group size="sm">
          <b-form-select id="sortBySelect" v-model="sortBy" :options="sortOptions" >
            <template #first>
              <option value="">
                none
              </option>
            </template>
          </b-form-select>
          <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" >
            <option :value="false">
              Asc
            </option>
            <option :value="true">
              Desc
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
      <!-- filter -->
      <b-form-group label="Filter" label-cols-sm="2" label-align-sm="left" label-size="sm" label-for="filterInput" class="mr-1" >
        <b-input-group size="sm">
          <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search"/>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table striped hover responsive class="position-relative" :per-page="perPage" :key="key" :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
      <template #cell(created_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(logo)="data">
        <b-img width="50" :src="data.value" />
      </template>
      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(action)="row">
        <span>
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item>
              <b-link :to="{ path: '/temperature/inventory/detail/'+ row.item.id}">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Detail</span>
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item style="display: none;">
              <b-link v-b-modal.modal-center
              @click="rowOnDelete(row.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
              </b-link>
            </b-dropdown-item>
          </b-dropdown>
        </span>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <p class="text-nowrap align-left">&nbsp;Total Rows {{totalRows}}</p>
      <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
      </b-form-group>
      <p class="text-nowrap mb-md-0 mr-1 align-left"></p>
      <!-- pagination -->
      <div>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card-code>
  </section>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BTable, BCol, BCard, BRow, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import moment from 'moment'
import XLSX from 'xlsx'
const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}))
const _SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'].map(function(x) { return '.' + x }).join(',')


export default {
  components: { XLSX, moment, BCardCode, vSelect, BTable, BCol, BCard, BRow, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent},
  data () {
    return {
      dir: false,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      select_6:'',
      select_7:'',
      select_8:'',
      filter: null,
      filterOn: [],
      key: 0,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      params: {
        province_id:'',
        regency_id:'',
      },
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  watch: {
    select_6 (obj) {
      this.$store.dispatch('region/regency', obj)
    },
    select_7 (obj) {
      this.$store.dispatch('region/district', obj)
    }
  },
  computed: {
    ...mapState({ 
      ProvinceOptions: state => state.region.province, 
      RegencyOptions: state => state.region.regency, 
      DistrictOptions: state => state.region.district,
      totalRows: state => state.temperature.inventory.totalRows, 
      fields: state => state.temperature.inventory.fields, 
      items: state => state.temperature.inventory.items, 
      perPage: state => state.temperature.inventory.perPage, 
      pageOptions: state => state.temperature.inventory.pageOptions, 
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat () {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction () {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch (val) {
      this.searchTerm = val
    },
    rowOnDelete (id) {
      this.$bvModal
      .msgBoxConfirm('Please confirm that you want to delete everything.', {
        title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
      })
      .then(value => {
        if (value === true){
          this.$store.dispatch('temperature.inventory', id)
          .then(response => {
            if (response.status === 200) {
              this.$store.dispatch('temperature/getInventory')
              this.notification('Success','CheckIcon','success','You have successfully')
            } else {
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          },
          error => {
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          }) 
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    exportExcel(evt) {
      const jsons = []
      for (let x = 0; x < this.items.length; x++) {
        jsons[x] = {
          'No': this.items[x].no,
          'Name': this.items[x].name,
          'Area Name': this.items[x].area_name,
          'Location Name': this.items[x].location_name,
          'Device Sum': this.items[x].device_sum,
          'Device Sum Active': this.items[x].device_sum_active,
          'Device Sum Deactive': this.items[x].device_sum_deactive,
          'Description': this.items[x].description
          // 'datetime': moment(String(this.items[x].datetime)).format('DD-MM-YYYY HH:mm:ss')
        }
      }
      const data_json = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
			XLSX.writeFile(wb, 'Inventory_data_'+moment(this.date_start).format('DD-MM-YYYY')+'_'+moment(this.date_finish).format('DD-MM-YYYY')+'.xlsx')
		},
    filterz () {
      this.params = {
        province_id:this.select_6,
        regency_id:this.select_7
      }
      this.$store.dispatch('temperature/getInventory', this.params)
    }
  },
  directives: {
    Ripple
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created () {
    this.$store.dispatch('region/province')
    this.params = {
      province_id:'',
      regency_id:''
    },
    this.$store.dispatch('temperature/getInventory',this.params)
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>